import { Map } from 'immutable';

import { actionTypes } from './actions';
import initialState from './initialState';

export default function servicesReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_START:
      return state.set('loading', true).set('data', null).set('error', null);
    case actionTypes.REQUEST_SUCCESS:
      return state.set('loading', false).set('data', mapServices(state, action.payload));
    case actionTypes.REQUEST_FAILURE:
      return state.set('loading', false).set('error', action.payload);
    default:
      return state;
  }
}

function mapServices(state, payload) {
  const service = { [payload.id]: payload.data };
  const data = state.get('data');
  const serviceMap = Map(service);

  return data ? data.merge(serviceMap) : serviceMap;
}
